// extracted by mini-css-extract-plugin
module.exports = {"acsmTargetStyle":"_1oTQ7ZjhZTpFxqV7tf4Rq1"};